__turbopack_context__.v({
  "courseHeader": "CourseLevelPage-module__2yrR6a__courseHeader",
  "courseHeaderContent": "CourseLevelPage-module__2yrR6a__courseHeaderContent",
  "courseHeaderNoBreadcrumb": "CourseLevelPage-module__2yrR6a__courseHeaderNoBreadcrumb",
  "labeledParagraph": "CourseLevelPage-module__2yrR6a__labeledParagraph",
  "labeledParagraphContent": "CourseLevelPage-module__2yrR6a__labeledParagraphContent",
  "labeledParagraphTitle": "CourseLevelPage-module__2yrR6a__labeledParagraphTitle",
  "labeledParagraphs": "CourseLevelPage-module__2yrR6a__labeledParagraphs",
  "main": "CourseLevelPage-module__2yrR6a__main",
  "summaryImage": "CourseLevelPage-module__2yrR6a__summaryImage",
  "textbooksList": "CourseLevelPage-module__2yrR6a__textbooksList",
});
